export const Types = {
  SET_LOADING: 'SET_LOADING',
  UNSET_LOADING: 'UNSET_LOADING'
}

export const setLoading = () => ({
  type: Types.SET_LOADING
})

export const unsetLoading = () => ({
  type: Types.UNSET_LOADING
})

export default function loading(state = { isLoading: false }, action) {
  switch (action.type) {
    case Types.SET_LOADING:
      return {
        ...state,
        isLoading: true
      }
    case Types.UNSET_LOADING:
      return {
        ...state,
        isLoading: false
      }
    default:
      return state
  }
}
